module.exports = __webpack_public_path__ + "img/1 (95).67aca158.png";